module.exports = __webpack_public_path__ + "static/media/400103_01.a4c03dc8.png";